import React, { useState, useEffect } from 'react';
import { holidayService } from '../services/api';

interface Holiday {
  id: number;
  name: string;
  date: string;
  description: string;
  isActive: boolean;
  createdAt: string;
}

const HolidayList: React.FC = () => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHolidays();
  }, []);

  const fetchHolidays = async () => {
    try {
      setLoading(true);
      const data = await holidayService.getHolidays();
      setHolidays(data);
    } catch (error) {
      console.error('Error fetching holidays:', error);
    } finally {
      setLoading(false);
    }
  };

  const isUpcoming = (date: string) => {
    return new Date(date) >= new Date();
  };

  const upcomingHolidays = holidays.filter(h => isUpcoming(h.date));
  const pastHolidays = holidays.filter(h => !isUpcoming(h.date));

  if (loading) {
    return <div>Loading holidays...</div>;
  }

  return (
    <div className="holiday-list">
      <h2>Company Holidays</h2>
      
      {upcomingHolidays.length > 0 && (
        <div className="holiday-section">
          <h3>Upcoming Holidays</h3>
          <div className="holidays-grid">
            {upcomingHolidays.map(holiday => (
              <div key={holiday.id} className="holiday-card upcoming">
                <div className="holiday-header">
                  <h4>{holiday.name}</h4>
                  <span className="holiday-date">
                    {new Date(holiday.date).toLocaleDateString()}
                  </span>
                </div>
                <p className="holiday-description">{holiday.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {pastHolidays.length > 0 && (
        <div className="holiday-section">
          <h3>Past Holidays</h3>
          <div className="holidays-grid">
            {pastHolidays.map(holiday => (
              <div key={holiday.id} className="holiday-card past">
                <div className="holiday-header">
                  <h4>{holiday.name}</h4>
                  <span className="holiday-date">
                    {new Date(holiday.date).toLocaleDateString()}
                  </span>
                </div>
                <p className="holiday-description">{holiday.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <style>{`
        .holiday-list {
          padding: 20px;
        }
        .holiday-section {
          margin-bottom: 30px;
        }
        .holiday-section h3 {
          color: #1e293b;
          border-bottom: 2px solid #7c3aed;
          padding-bottom: 5px;
          margin-bottom: 15px;
        }
        .holidays-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 15px;
        }
        .holiday-card {
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 15px;
          background: white;
          box-shadow: 0 2px 4px rgba(15,23,42,0.08);
        }
        .holiday-card.upcoming {
          border-left: 4px solid #059669;
        }
        .holiday-card.past {
          border-left: 4px solid #64748b;
          opacity: 0.7;
        }
        .holiday-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }
        .holiday-header h4 {
          margin: 0;
          color: #1e293b;
        }
        .holiday-date {
          background: #7c3aed;
          color: white;
          padding: 4px 8px;
          border-radius: 10px;
          font-size: 0.9em;
        }
        .holiday-card.past .holiday-date {
          background: #64748b;
        }
        .holiday-description {
          color: #64748b;
          margin: 0;
          font-size: 0.9em;
        }
      `}</style>
    </div>
  );
};

export default HolidayList;